import { builtins, builtinVerbs } from '#core/lib/expr/builtins.ts';
import { createOpTable, createVerbTable } from '#core/lib/expr/op-meta.ts';
import { dashboardOps } from '#core/lib/expr/ops/dashboard/index.ts';
import { knowledgeGraphOps } from '#core/lib/expr/ops/knowledge-graph/index.ts';
import { transformOps, transformVerbs } from '#core/lib/expr/ops/transform/index.ts';

// Op + verb tables composed once at module load — every chat session
// shares the same dispatch tables. Adding a new chat-side op set is
// `createOpTable([...builtins, ...kgOps, ...transformOps, ...newOps])`;
// likewise for verbs via `createVerbTable`. Single source of truth: the
// session provider, the hydration replay, and the binding store's
// `reservedNames` all read from here so op-name shadowing is rejected
// identically everywhere.
export const CHAT_OPS_TABLE = createOpTable([...builtins, ...knowledgeGraphOps, ...transformOps, ...dashboardOps]);
export const CHAT_VERBS_TABLE = createVerbTable([...builtinVerbs, ...transformVerbs]);

/**
 * The registered top-level op names — fed to the binding store's
 * `reservedNames` so a tool/`(dataset …)` binding that shadows an op
 * name throws `ShadowingOpError` (parity with the engine's lexical
 * `checkBindable`). Derived from `CHAT_OPS_TABLE` so the reserved set
 * can never drift from the actual dispatch table.
 */
export const CHAT_RESERVED_NAMES = new Set(CHAT_OPS_TABLE.keys());
